import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnvNoticeComponent } from './env-notice';

@NgModule({
  declarations: [EnvNoticeComponent],
  imports: [CommonModule],
  exports: [EnvNoticeComponent]
})
export class EnvNoticeModule { }



// WEBPACK FOOTER //
// ./src/components/env-notice/env-notice.module.ts